
import { defineComponent, ref } from "vue";
import AppFooter from "@/components/common/AppFooter.vue";
import { mapGetters, mapMutations } from "vuex";
import messages from "@/config/messages";
import helper from "@/utils/helper";
import common from "@/config/common";
import routesPath from "@/config/routesPath";
import * as apiClient from "@/apiclient/";
import eventBus from "@/utils/eventBus";

export default defineComponent({
  name: "DocumentView",
  components: {
    AppFooter,
  },
  data() {
    return {
      files: [],
      isDragging: false,
      validationMsg: "",
      noticeLetterData: null as string | null,
    };
  },
  computed: {
    ...mapGetters([
      "getDocumentSubmitBtn",
      "getDocumentsUploaded",
      "getEnrollment",
    ]),
  },
  async created() {
    eventBus.emit("toggle-enrollments-menu", false);
    await this.fetchNoticeLetter();
  },
  methods: {
    ...mapMutations([
      "setUploadFile",
      "setTotalFiles",
      "setUploadedFiles",
      "removeUploadFile",
      "removeUploadFiles",
      "setShowModal",
      "setModalTitle",
      "setModalContent",
      "setDocumentsUploaded",
      "removeUploadProgress",
      "setDocumentSubmitBtn",
    ]),
    submitHandler() {
      helper.setPageStep(common.pageStep.documents);
      this.$router.push({ name: routesPath.confirmation });
    },
    handleFileChange(event: any) {
      this.files = event.target.files;
      this.uploadFile();
      event.target.value = null;
    },
    handleDrop(event: any) {
      event.preventDefault();
      this.files = event.dataTransfer.files;
      this.isDragging = false;

      this.uploadFile();
      event.target.value = null;
    },
    handleDragLeave(event: any) {
      event.preventDefault();
      this.isDragging = false;
    },
    handleDragOver(event: any) {
      event.preventDefault();
      this.isDragging = true;
    },
    async fetchNoticeLetter() {
      try {
        const params = {
          customerParticipantId: this.getEnrollment.customerParticipantId,
        };
        const response = await apiClient
          .documentController()
          .getApiDocumentGetQenotice(params);
        if (response.data && response.data.fileContents) {
          this.noticeLetterData = response.data.fileContents;
        }
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },
    async uploadFile() {
      if (!this.files.length) return;
      if (this.notValidFileType()) {
        this.setShowModal(true);
        this.setModalTitle("Alert!");
        this.setModalContent(messages.notAllowedDocument);
        return;
      }

      this.setTotalFiles(this.files.length);
      const uploadedFiles = Array.from(this.files);
      var failedFile = false;
      for (let index = 0; index < uploadedFiles.length; index++) {
        var file = uploadedFiles[index] as any;

        this.setUploadedFiles(index + 1);
        this.setUploadFile({
          name: file.name,
          type: file.type,
          size: file.size,
          show: true,
          disabled: false,
        });
        const params: apiClient.PostApiDocumentMutationRequest = {
          File: file,
          customerParticipantId:
            this.getEnrollment.customerParticipantId.toString(),
        };
        const result = await apiClient
          .documentController()
          .postApiDocument(params);

        if (result.error) {
          failedFile = true;
          this.removeUploadProgress(index);
          this.removeUploadFile(index);
          this.validationMsg = result.error + messages.errorMsg;
          console.error("Error uploading file:", result.error);
        } else if (result.data) {
          const electionUploadId = result.data;
          const uploadedDoc = {
            fileName: file.name,
            electionUploadId,
            contentType: file.type,
            fileSize: file.size,
            disabled: false,
          };

          this.setDocumentsUploaded([
            ...this.getDocumentsUploaded,
            uploadedDoc,
          ]);
          this.setDocumentSubmitBtn(common.saveNext);
        }
      }

      this.setTotalFiles(0);
      this.setUploadedFiles(0);
      this.removeUploadFiles();
      if (!failedFile) {
        this.validationMsg = "";
      }
    },
    async downloadNoticeLetter() {
      if (!this.noticeLetterData) {
        return;
      }

      // Create a blob from the response data
      const blob = new Blob([helper.base64ToUint8Array(this.noticeLetterData)]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "QE Notice Letter.pdf");
      document.body.appendChild(link);
      link.click();

      // Clean up the URL and link element
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    },
    notValidFileType() {
      const allowedFileTypes = [
        "image/tiff",
        "image/bmp",
        "image/png",
        "image/jpeg",
        "application/pdf",
      ];

      return Array.from(this.files).some(
        (file: File) => allowedFileTypes.indexOf(file.type) === -1
      );
    },
  },
});
